export default "__VITE_ASSET__BnAYJzdi__";